module.exports = __webpack_public_path__ + "static/media/advisory_entry_hero.d48fc6ce.svg";